export default __webpack_public_path__ + "static/to_do_list_nothing.f87822d9b08485377d97a4c0877ad076.jpg";